import { render, staticRenderFns } from "./StatusRepairModal.vue?vue&type=template&id=3b020656&scoped=true&"
import script from "./StatusRepairModal.vue?vue&type=script&lang=js&"
export * from "./StatusRepairModal.vue?vue&type=script&lang=js&"
import style0 from "./StatusRepairModal.vue?vue&type=style&index=0&id=3b020656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b020656",
  null
  
)

export default component.exports